
import React from 'react';
import { Activity } from 'lucide-react';

const WaterDistributionEfficiency = () => {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="p-4 flex flex-col items-center justify-center h-full w-full">
        <h3 className="text-lg font-medium text-gray-800 dark:text-white mb-2">Distribution Efficiency</h3>
        <div className="mb-2">
          <Activity className="h-7 w-7 text-blue-500 mb-2" />
        </div>
        <div className="relative h-12 w-12 mb-2">
          <svg className="w-full h-full" viewBox="0 0 100 100">
            <circle 
              cx="50" cy="50" r="45" 
              fill="none" 
              stroke="#334155" 
              strokeWidth="8" 
            />
            <circle 
              cx="50" cy="50" r="45" 
              fill="none" 
              stroke="#3b82f6" 
              strokeWidth="8"
              strokeDasharray="283"
              strokeDashoffset="24"
              transform="rotate(-90 50 50)"
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-xs font-bold text-blue-500">91%</span>
          </div>
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-300">Current distribution efficiency</p>
      </div>
    </div>
  );
};

export default WaterDistributionEfficiency;
